__turbopack_context__.v({
  "icon": "Logo-module-scss-module__i2LYIW__icon",
  "type": "Logo-module-scss-module__i2LYIW__type",
});
